import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupRestrictedActionsOffAllContentProps } from './msg-group-restricted-actions-off-all-content';
import { MsgGroupRestrictedActionsOffAllContent } from './msg-group-restricted-actions-off-all-content';

export interface MsgGroupRestrictedActionsOffAllPreviewProps
  extends MsgGroupRestrictedActionsOffAllContentProps {}

export const MsgGroupRestrictedActionsOffAllPreview = memo(
  function MsgGroupRestrictedActionsOffAllPreview({
    message,
  }: MsgGroupRestrictedActionsOffAllPreviewProps) {
    return (
      <LastMessageSystem>
        <MsgGroupRestrictedActionsOffAllContent message={message} />
      </LastMessageSystem>
    );
  }
);
